/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */

// TODO(rictic): do more robust benchmarks and pick a winner.
export {hydrateShadowRoots} from './manual_walk.js';
